const e = {
  "ld.startEditing": "Start editing.",
  "ld.dashboard": "Mój panel",
  "ld.search": "Search",
  "ld.browse": "Browse",
  "ld.reset": "Reset",
  "ld.searchResource": "Search resources",
  "ld.create": "Create resource",
  "ld.edit": "Edytuj",
  "ld.editResource": "Edit resource",
  "ld.main": "Main",
  "ld.and": "AND",
  "ld.or": "OR",
  "ld.not": "NOT",
  "ld.saveRd": "Save resource",
  "ld.closeRd": "Close resource",
  "ld.deleteRd": "Delete resource",
  "ld.resources": "Resources",
  "ld.searchBy": "Search By",
  "ld.searchFor": "Szukaj",
  "ld.searchAndFilter": "Search & filter",
  "ld.enterSearchCriteria": "Enter search criteria to start search",
  "ld.chooseFilterOrEnterSearchQuery": "Choose a filter or enter a search query to show results.",
  "ld.searchNoRdsMatch": "No resource descriptions match your query",
  "ld.searchBySth": "Search by{by}...",
  "ld.errorFetching": "Error fetching data",
  "ld.errorLoadingResource": "Error loading resource",
  "ld.actions": "Akcje",
  "ld.isbnLccn": "ISBN/LCCN",
  "ld.isbn": "ISBN",
  "ld.lccn": "LCCN",
  "ld.lcnaf": "LCNAF",
  "ld.title": "Tytuł",
  "ld.contributor": "Contributor",
  "ld.author": "Author",
  "ld.pubDate": "Publication Date",
  "ld.pubDateShort": "Pub Date",
  "ld.edition": "Edition",
  "ld.select": "Select",
  "ld.subclass": "Subclass",
  "ld.heading": "Heading",
  "ld.selectForEditing": "Select a resource description for editing",
  "ld.startFromScratch": "Start from scratch",
  "ld.selectOrStartFromScratch": "{select} or {startFromScratch}",
  "ld.backToTop": "Back to top",
  "ld.preview": "Preview",
  "ld.confirmCloseRd": "Do you really want to close the resource description? All unsaved changes will be lost.",
  "ld.confirmDeleteRd": "Do you really want to delete the resource description?",
  "ld.saveClose": "Save and close",
  "ld.close": "Close",
  "ld.delete": "Usuń",
  "ld.return": "Return",
  "ld.rdSaveSuccess": "Resource created. Expect a short delay before resource is visible in FOLIO.",
  "ld.rdUpdateSuccess": "Resource updated. Expect a short delay before changes are visible in FOLIO.",
  "ld.cantSaveRd": "Cannot save the resource description",
  "ld.cantDeleteRd": "Cannot delete the resource description",
  "ld.rdDeleted": "Resource description deleted",
  "ld.appFail": "An error occurred. Please, reload the page.",
  "ld.searchSelectIndex": "Please select an index",
  "ld.advancedSearch": "Advanced search",
  "ld.advanced": "Advanced",
  "ld.cancel": "Cancel",
  "ld.loading": "Loading...",
  "ld.paginationCount": "{startCount} - {endCount} of {totalResultsCount}",
  "ld.yes": "Tak",
  "ld.no": "Nie",
  "ld.cantLoadSimpleLookupData": "Cannot load data for a simple lookup",
  "ld.publishDate": "Publish date",
  "ld.format": "Format",
  "ld.suppressed": "Suppressed",
  "ld.notSuppressed": "Not suppressed",
  "ld.volume": "Volume",
  "ld.ebook": "eBook",
  "ld.allTime": "All time",
  "ld.past12Months": "Past 12 months",
  "ld.past10Yrs": "Past 10 years",
  "ld.past5Yrs": "Past 5 years",
  "ld.customRange": "Custom range",
  "ld.all": "All",
  "ld.onlineResource": "Online resource",
  "ld.startsWith": "Starts with",
  "ld.containsAll": "Contains all",
  "ld.exactPhrase": "Exact phrase",
  "ld.publisher": "Publisher",
  "ld.creator": "Creator",
  "ld.language": "Language",
  "ld.classificationNumber": "Classification number",
  "ld.work": "Work",
  "ld.instances": "Instances",
  "ld.noInstancesAvailable": "No instances available.",
  "ld.noInstancesAdded": "No instances added",
  "ld.addAnInstance": "Add an instance",
  "ld.type": "Type",
  "ld.expandAll": "Expand all",
  "ld.collapseAll": "Collapse all",
  "ld.showAllWithCount": "Show all ({amt})",
  "ld.showAdditionalComponents": "Show additional components ({amt})",
  "ld.hideAdditionalComponents": "Hide additional components",
  "ld.hide": "Hide",
  "ld.saveAndClose": "Save & close",
  "ld.saveAndContinue": "Save & continue",
  "ld.editInstance": "Edytuj instancję",
  "ld.editWork": "Edit work",
  "ld.createInstance": "Create instance",
  "ld.createWork": "Create work",
  "ld.saveAndKeepEditing": "Save & keep editing",
  "ld.recordMappingToSchema": "Cannot apply a record to the schema",
  "ld.newResource": "New resource",
  "ld.addInstance": "Add instance",
  "ld.compareSelected": "Compare selected",
  "ld.newInstance": "New instance",
  "ld.newWork": "New work",
  "ld.new": "New",
  "ld.cantSelectReferenceContents": "Can't select reference contents while fetching a reference",
  "ld.addNewInstance": "Add new instance",
  "ld.askSaveChangesBeforeProceeding": "Would you like to save your changes before proceeding?",
  "ld.unsavedRecentEdits": "Recent edits made to the resource have not been saved. Unsaved changes will be lost.",
  "ld.unsavedChanges": "Unsaved changes",
  "ld.continueWithoutSaving": "Continue without saving",
  "ld.noTitleInBrackets": "No title",
  "ld.viewMarc": "View MARC",
  "ld.marcWithTitle": "MARC - {title}",
  "ld.cantLoadMarc": "Can't load MARC for this resource description",
  "ld.duplicate": "Duplicate",
  "ld.viewLinkedData": "View linked data",
  "ld.viewInInventory": "View in Inventory app",
  "ld.authorityType": "Authority Type",
  "ld.person": "Person",
  "ld.source": "Source",
  "ld.family": "Family",
  "ld.organization": "Organizacja",
  "ld.meeting": "Meeting",
  "ld.corporateBody": "Corporate body",
  "ld.jurisdiction": "Jurisdiction",
  "ld.conference": "Conference",
  "ld.authorizedReference": "Główne/Odsyłacz",
  "ld.headingReference": "Hasło/Odsyłacz",
  "ld.unauthorized": "Unauthorized",
  "ld.assign": "Przypisz",
  "ld.assignAuthority": "Assign authority",
  "ld.change": "Change",
  "ld.searchCreatorAuthority": "Search creator authority",
  "ld.selectMarcAuthority": "Select MARC authority",
  "ld.marcAuthority": "MARC authority",
  "ld.keyword": "Keyword",
  "ld.recordsFound": "{recordsCount} records found",
  "ld.resourceWithIdIsEmpty": "Resource description {id} is empty",
  "ld.duplicateInstance": "Duplicate instance",
  "ld.duplicateWork": "Duplicate work",
  "ld.duplicateInstanceInBrackets": "(DUPLICATE INSTANCE)",
  "ld.duplicateWorkInBrackets": "(DUPLICATE WORK)",
  "ld.identifierAll": "Identyfikator (wszystko)",
  "ld.personalName": "Nazwa osobowa",
  "ld.corporateName": "Corporate/Conference name",
  "ld.geographicName": "Geographic name",
  "ld.nameTitle": "Name-title",
  "ld.uniformTitle": "Uniform title",
  "ld.subject": "Hasło przedmiotowe",
  "ld.childrensSubjectHeading": "Children's subject heading",
  "ld.genre": "Genre",
  "ld.authoritySource": "Authority source",
  "ld.references": "References",
  "ld.thesaurus": "Thesaurus",
  "ld.typeOfHeading": "Type of heading",
  "ld.dateCreated": "Date created",
  "ld.dateUpdated": "Data aktualizacji",
  "ld.excludeSeeFrom": "Exclude see from",
  "ld.excludeSeeFromAlso": "Exclude see from also",
  "ld.previous": "Previous",
  "ld.next": "Next",
  "ld.from": "From",
  "ld.to": "To",
  "ld.apply": "Apply",
  "ld.notSpecified": "Not specified",
  "ld.externalResourcePreview": "External resource preview",
  "ld.errorFetchingExternalResourceForPreview": "Error fetching external resource for preview",
  "ld.fetchingExternalResourceById": "Fetching external resource id {resourceId}...",
  "ld.lastUpdated": "Ostatnia aktualizacja",
  "ld.marcAuthorityRecord": "MARC authority record",
  "ld.selectBrowseOption": "Select a browse option",
  "ld.searchQueryWouldBeHere": "{query} would be here",
  "ld.continue": "Continue",
  "ld.aria.filters.select": "Select search identifiers",
  "ld.aria.filters.textbox": "Search query textbox",
  "ld.aria.filters.reset": "Reset filters button",
  "ld.aria.filters.reset.announce": "Search field and filters are reset",
  "ld.backToInventory": "Back to inventory",
  "ld.properties": "Properties",
  "ld.errorFetchingExternalResourceForEditing": "Error fetching external resource for editing",
  "ld.duplicateImportWarn": "Duplicate import warning",
  "ld.rdPropertiesMatchContinue": "Properties of this resource match an existing resource. Do you want to continue?",
  "ld.instance": "Instance",
  "ld.year": "Year",
  "ld.aria.modal.close": "Close {modalKind} modal",
  "ld.aria.advancedSearch.queryInput": "Advanced search row query input",
  "ld.aria.advancedSearch.operator": "Advanced search row operator",
  "ld.aria.advancedSearch.qualifier": "Advanced search row qualifier",
  "ld.aria.advancedSearch.identifier": "Advanced search row identifier",
  "ld.aria.listEntry.open": "Open collapsible list entry",
  "ld.aria.listEntry.close": "Close collapsible list entry",
  "ld.aria.table.selectRow": "Select resource: {title}",
  "ld.aria.sections.openResourcePreview": "Open resource preview section: {title}",
  "ld.aria.sections.closeResourcePreview": "Close resource preview section",
  "ld.aria.edit.close": "Close edit page",
  "ld.aria.edit.deleteComponent": "Delete component",
  "ld.aria.edit.duplicateComponent": "Duplicate component",
  "ld.aria.resourcePreview.close": "Close resource preview pane",
  "ld.aria.externalResourcePreview.close": "Close external resource preview page",
  "ld.aria.marcAuthorityPreview.close": "Close MARC authority preview",
  "ld.aria.marcPreview.close": "Close MARC preview modal",
  "ld.aria.complexLookup.marcPreview.close": "Close lookup MARC preview section",
  "ld.aria.edit.removeComplexLookupFieldValue": "Remove complex lookup field value",
  "ld.errorMakingApiRequest": "Error making API request",
  "ld.compareResources": "Porównaj zasoby",
  "ld.selectedResources": "Wybrane zasoby",
  "ld.nResourcesSelected": "{n} wybrane zasoby",
  "ld.clearSelections": "Wyczyść zaznaczenia",
  "ld.chooseTwoResourcesCompare": "Wybierz dwa lub więcej zasobów do porównania",
  "ld.chooseOneResourceCompare": "Wybierz inny zasób do porównania",
  "ld.aria.comparison.close": "Close comparison section",
  "ld.aria.comparison.removeEntry": "Remove comparison entry",
  "ld.aria.searchPane.close": "Zamknij panel wyszukiwania",
  "ld.aria.searchPane.open": "Otwórz panel wyszukiwania",
  "ld.modal.uncontrolledAuthoritiesWarning.title": "Ostrzeżenie o niektontrolowanych hasłach",
  "ld.modal.uncontrolledAuthoritiesWarning.body": `Ten opis obejmuje jeden lub więcej niekontrolowanych haseł.
Czy chcesz zapisać zmiany?`,
  "ld.errorAssigningAuthority": "Błąd przypisywania hasła",
  "ld.errorAssigningAuthority.not_valid_for_target": "Wybierz kartotekę, której typ zasobu odpowiada edytowanemu polu kartoteki (np. kartoteka LCNAF dla pola Twórca)",
  "ld.errorAssigningAuthority.no_lccn": "Tylko kartoteka Biblioteki Kongresu może być przypisana do zasobu bibliograficznego. To ograniczenie jest tymczasowe, dopóki Edytor Linked Data nie będzie obsługiwał dodatkowych typów źródeł.",
  "ld.errorAssigningAuthority.unsupported_marc": "Wybrana kartoteka nie została zmapowana do Linked Data i nie może zostać przypisana do zasobu w tym momencie. To ograniczenie jest tymczasowe, dopóki mapowanie tagów KHW nie zostanie ukończone.",
  "ld.required_primary_main_title": "Proszę podać tytuł główny, aby zapisać.",
  "ld.lccn_does_not_match_pattern": "Włączono walidację wzoru LCCN: Podaj wzór LCCN zgodny ze standardową strukturą.",
  "ld.lccn_not_unique": "Włączono unikalność LCCN: Podany przez Ciebie LCCN już istnieje. Podaj inny LCCN.",
  "ld.failed_dependency": "Nie można sprawdzić czy LCCN jest .",
  "ld.not_found": "Identyfikator zasobu został zmieniony przez innego użytkownika, gdy miałeś otwarty ten zasób. Odśwież okno przeglądarki.",
  "ld.mapping": "Wystąpił problem z mapowaniem. Zgłoś to swojemu zespołowi wsparcia, dołączając zrzuty ekranu i szczegółowy opis tego, co się stało.",
  "ld.generic_bad_request": "Wystąpił problem z interfejsem użytkownika. Zgłoś to swojemu zespołowi wsparcia, dołączając zrzuty ekranu i szczegółowy opis tego, co się stało.",
  "ld.server": "Wystąpił problem z serwerem. Zgłoś to swojemu zespołowi wsparcia, dołączając zrzuty ekranu i szczegółowy opis tego, co się stało.",
  "ld.already_exists": "Taki sam identyfikator zasobu już istnieje.",
  "ld.aria.sections.editInstance": "Edit instance: {title}"
};
export {
  e as default
};
